import React from "react"
import { createIcon } from "@chakra-ui/react"

export default createIcon({
  displayName: "AcreSignIcon",
  viewBox: "0 0 24 24",
  path: [
    <circle cx="12" cy="12" r="12" fill="#F34900" />,
    <path
      d="M15.4926 14.1188L14.57 12.7961H9.39512L8.47246 14.1188H11.3848V15.5617H4.46094V14.1188H6.80367L10.2696 9.18897H8.19166V7.74609H15.7734V9.18897H13.6955L17.1614 14.1188H19.5042V15.5617H12.5883V14.1188H15.5007H15.4926ZM10.2696 11.5376H13.6874L11.9785 9.10881L10.2696 11.5376Z"
      fill="#F3E5C1"
    />,
  ],
})
